import { createGlobalState } from '@vueuse/core'
import { is_small_screen } from '../../../utils'
import { computed } from 'vue'

export const useFixedHeaderHeight = createGlobalState(() => {
  const fixedHeaderHeight = computed(() => is_small_screen() ? 55 : 65)

  return {
    fixedHeaderHeight
  }
})
